import React, { Component } from "react";

import { Link } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';
import CustomerProductRow from "./CustomerProductRow.js";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import {searchFilterService} from "../../Services/SearchFilterService.js";

class CustomerProductsList extends Component {
	constructor(props) {
		super(props);
	}
	
	render() {
		var products = new Array();
		var prod;
//		console.log(this.props.tmxRecords);
		this.props.products.sort((a, b) => {
//		Object.values(this.props.products).sort(function(a, b) {
				if(a.description < b.description){
					return -1;
				}else if(a.description == b.description){
					if(this.props.langPairs[a.langPair].code < this.props.langPairs[b.langPair].code){
						return -1;
					}if(this.props.langPairs[a.langPair].code > this.props.langPairs[b.langPair].code){
						return 1;
					}if(this.props.langPairs[a.langPair].code == this.props.langPairs[b.langPair].code){
						return 0;
					}
				}else if(a.description > b.description){
					return 1;
				}
			}).forEach((product) => {
			prod = <CustomerProductRow
				id = {product.id}
				customer = {this.props.id}
				suppliers = {product.suppliers}
				supplierConfig={this.props.supplierConfig}
				users={this.props.users}
				description = {product.description}
				langPairId = {product.langPair}
				langPairCode = {this.props.langPairs[product.langPair].code}
				tmx={this.props.tmxRecords.find(tmx => {if(tmx.languagePair.id == product.langPair){ return true;}})}
				//tmx={searchFilterService.objectFilter(this.props.tmxRecords, (tmx => {if(tmx.languagePair.id == product.langPair){ return true;}}))}
				morePriority={this.props.morePriority}
				changConfig={this.props.changConfig}
				wfConfig={product.wfConfig}
				glossary={this.props.glosaris.find(g => {if(g.languagePair.id == product.langPair){ return true;}})}
				accessToken={this.props.accessToken}
			/>;
			products.push(prod);
		});
		return (
		<Table className="lst">
		    <TableHead>
		      <TableRow>
				<TableCell>Task</TableCell>
				<TableCell>Configuration</TableCell>
				<TableCell>Lang Pair</TableCell>
				<TableCell>Supplyers</TableCell>
				<TableCell align="center">Glossary</TableCell>
				<TableCell align="center">TMX</TableCell>
		      </TableRow>
		    </TableHead>
		    <TableBody>{products}</TableBody>
		  </Table>
		)
	}
}

export default CustomerProductsList;